export default {
  manageProvidersHeader: 'Manage Providers',
  providerName: 'Provider Name',
  providerStatus: 'Provider Status',
  providerCreatedSuccess: '{provider} was created successfully.',
  createNewProvider: 'Create New Provider',
  active: 'Active',
  inactive: 'Inactive',
  deactivateProvider: 'Deactivate Provider',
  deactivateProviderMessage: 'Are you sure you want to deactivate provider?',
  noChangesTooltip: 'There are no changes to save.',
};
